var map = {
	"./about.json": 331,
	"./de.json": 332,
	"./fr.json": 333,
	"./it.json": 334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;


//////////////////
// WEBPACK FOOTER
// ./src/i18next ^\.\/.*\.json$
// module id = 330
// module chunks = 0